import React from 'react';
import ShowReservation from '../components/ShowReservations';

const Reservations = () => (
  <>
    <ShowReservation />
  </>
);

export default Reservations;
